<template>
  <validation-observer ref="formIndividual">
    <b-form @submit.prevent>
      <b-row>
        <b-col cols="12" sm="10">
          <validation-provider
            rules="required"
            v-slot="{ errors }"
            name="Lead Source"
            vid="Lead Source"
          >
            <b-form-group label="Lead Source*" label-for="h-First">
              <b-form-select
                v-model="individual.profile.source"
                :options="sourceDDL"
              />
              <small v-if="errors.length" class="text-danger">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" sm="2" class="d-flex align-items-center">
          <b-button
            variant="primary"
            class="w-100"
            @click="showModal('Source')"
          >
            Add Source
          </b-button>
        </b-col>

        <b-col cols="12">
          <b-form-group label="First Name*" label-for="h-First">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="First Name"
              vid="First Name"
            >
              <b-form-input
                id="h-First"
                placeholder="First Name*"
                v-model="individual.fName"
              />
              <small v-if="errors.length" class="text-danger">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Last Name*" label-for="h-Last">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="Last Name"
              vid="Last Name"
            >
              <b-form-input
                id="h-Last"
                placeholder="Last Name"
                v-model="individual.lName"
              />
              <small v-if="errors.length" class="text-danger">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-button
            v-on:click="isCollapseInd = !isCollapseInd"
            variant="primary"
          >
            {{ this.isCollapseInd ? "See More" : "See Less" }}
          </b-button>
        </b-col>

        <b-col v-if="!isCollapseInd" cols="12">
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="Sales Person"
              vid="Sales Person"
            >
              <b-form-group label="Sales Person" label-for="h-First">
                <b-form-select
                  v-model="individual.salesPersonId"
                  :options="salesPersonDDL"
                />
                <small v-if="errors.length" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12">
            <validation-provider v-slot="{ errors }" name="Title" vid="Title">
              <b-form-group label="Titles" label-for="h-First">
                <b-form-select v-model="individual.title" :options="options" />
                <small v-if="errors.length" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- email -->
          <b-col cols="12">
            <validation-provider
              rules="email_regex"
              v-slot="{ errors }"
              name="Email"
              vid="Email"
            >
              <b-form-group label="Email" label-for="d-email">
                <b-form-input
                  id="d-email"
                  type="email"
                  placeholder="Enter your email (e.g., example@domain.com)"
                  v-model="individual.email"
                />
                <small v-if="errors.length" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- DOB  -->
          <b-col cols="12">
            <b-form-group label="Date of Birth" label-for="dob">
              <flat-pickr
                v-model="individual.dob"
                class="form-control"
                :config="config"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Address Line 1" label-for="h-Address">
              <b-form-input
                id="h-Address"
                placeholder="Address"
                v-model="individual.addressLine1"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Address Line 2" label-for="h-Address Line 2">
              <b-form-input
                id="h-Address Line 2"
                placeholder="Address Line 2"
                v-model="individual.addressLine2"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="10">
            <b-form-group label="City" label-for="h-City">
              <b-form-select
                v-model="individual.profile.city"
                :options="cityDDL"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="2" class="d-flex align-items-center">
            <b-button
              variant="primary"
              class="w-100"
              @click="showModal('City')"
            >
              Add City
            </b-button>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Telephone" label-for="h-Telephone">
              <b-form-input
                id="h-Telephone"
                placeholder="Telephone"
                type="number"
                onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                v-model="individual.tel"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group
              label="Category"
              label-for="h-SpecialInstructions"
            >
              <b-form-input
                id="h-SpecialInstructions"
                placeholder="Category"
                v-model="individual.fieldInstruction"
              />
            </b-form-group>
          </b-col>

          <b-col cols="10">
            <b-form-group label="Job Title" label-for="h-title">
              <b-form-select
                v-model="individual.profile.jobTitle"
                :options="jobTitleDDL"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="2" class="d-flex align-items-center">
            <b-button
              variant="primary"
              class="w-100"
              @click="showModal('JobTitle')"
            >
              Add Job Title
            </b-button>
          </b-col>
          <!-- Hobbies -->
          <b-col cols="10">
            <b-form-group label="Hobbies" label-for="h-title">
              <v-select
                multiple
                placeholder="Add Hobbies"
                label="itemTitle"
                v-model="individual.profile.hobbies"
                :options="hobbiesDDL"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="2" class="d-flex align-items-center">
            <b-button
              variant="primary"
              class="w-100"
              @click="showModal('HOBBIE')"
            >
              Add Hobby
            </b-button>
          </b-col>
          <!-- products interested in  -->
          <b-col cols="10">
            <b-form-group label="Products Interested in" label-for="h-title">
              <v-select
                multiple
                placeholder="Add Products Interested in"
                label="itemTitle"
                v-model="individual.profile.productsInterestedIn"
                :options="productInterestDDL"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="2" class="d-flex align-items-center">
            <b-button
              variant="primary"
              class="w-100"
              @click="showModal('ProductInterest')"
            >
              Add Product Interest
            </b-button>
          </b-col>
          <!-- Segment -->
          <b-col cols="12">
            <b-form-group label="Marketing Segment" label-for="h-title">
              <v-select
                multiple
                placeholder="Add Marketing Segments"
                label="itemTitle"
                v-model="individual.profile.marketingSegments"
                :options="segmentOptions"
              />
            </b-form-group>
          </b-col>
          <!-- Percentage -->
          <b-col cols="12">
            <b-form-group label="Percentage" label-for="d-percentage">
              <div class="input-group">
                <b-form-input
                  id="d-percentage"
                  type="number"
                  placeholder="Percentage"
                  v-model.number="individual.percentage"
                  min="0"
                  max="100"
                />
                <div class="input-group-append">
                  <span class="input-group-text">%</span>
                </div>
              </div>
            </b-form-group>
          </b-col>
        </b-col>
      </b-row>

      <CustomFieldsDetails
        v-if="!isCollapseInd"
        :AdditionalFields="individual.additionalFields"
        :ModuleReference="'LeadClient'"
        @onchange="additionalFieldChanges"
      ></CustomFieldsDetails>
    </b-form>
    <b-modal :id="modalId" :title="modalTitle" hide-footer>
      <b-form @submit.prevent="addItem">
        <b-form-group
          :label="`Add ${modalTitle}`"
          label-for="input-new-item"
        >
          <b-form-input
            id="input-new-item"
            v-model="newItem"
            required
            placeholder="Enter new item"
          ></b-form-input>
        </b-form-group>
        <b-button type="submit" variant="primary">Add</b-button>
      </b-form>

      <div class="p-1" style="max-height: 500px; overflow-y: auto">
        <b-table
          striped
          hover
          :items="modalOptions"
          responsive
          :fields="fields"
        >
          <template v-slot:cell(name)="data">
            {{
              modalType === "PRODUCTINTEREST" || "HOBBIE"
                ? data.item.itemTitle
                : data.item.text
            }}
          </template>
          <template #cell(actions)="data">
            <b-button
              size="sm"
              variant="danger"
              @click="deleteItem(data.item.value)"
              >Delete</b-button
            >
          </template>
        </b-table>
      </div>
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BFormText,
  BFormTextarea,
  BDropdown,
  BDropdownItem,
  BCollapse,
  VBToggle,
  BFormDatalist,
  BCard,
  BFormDatepicker,
  BFormSelect,
  BModal,
  VBModal,
  BTable,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import { mapActions, mapGetters } from "vuex";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { ModuleReferenceList } from "@/libs/defaultList";
import CustomFieldsDetails from "@/views/component/CustomFieldsDetails.vue";
import { fnSortingDropdown } from "@/libs/customFn";
import { extend } from "vee-validate";

extend("email_regex", {
  validate: value =>
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value),
  message: "Please enter a valid email address in the format example@domain.com",
});
export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BFormText,
    BButton,
    BFormDatalist,
    BDropdown,
    BDropdownItem,
    BFormSelect,
    BFormTextarea,
    ValidationProvider,
    BFormDatepicker,
    ValidationObserver,
    vSelect,
    flatPickr,
    BModal,
    BCard,
    VBModal,
    BTable,
    BCollapse,
    CustomFieldsDetails,
  },
  directives: {
    Ripple,
    VBToggle,
  },

  props: {
    individual: {
      type: Object,
      default: () => ({
        source: null,
        title: null,
        specifySource: "",
      }),
    },
  },
  props: {
    individual: {
      type: Object,
      default: () => ({
        source: null,
        specifySource: "",
      }),
    },
  },
  data() {
    return {
      fields: [{ key: "name", sortable: true }, { key: "actions" }],
      options: [
        { value: null, text: "Please select a title" },
        { value: "Mr", text: "Mr" },
        { value: "Mrs", text: "Mrs" },
        { value: "Ms", text: "Ms" },
      ],
      isCollapseInd: true,
      optionsSalesPerson: [],
      sourceOptions: [],
      productInterestOptions: [],
      hobbiesOptions: [],
      cityOptions: [],
      jobTitleOptions: [],
      previousIndividual: null,
      modalId: "",
      modalTitle: "",
      modalType: "",
      newItem: "",
      currentOptions: [],
      socialMedias: [
        { text: "Facebook", value: 1 },
        { text: "Instagram", value: 2 },
        { text: "LinkedIn", value: 4 },
        //{ text: "Other", value: 0 },
        { text: "Twitter", value: 3 },
      ],
      selected: "Select Social Media",
      ///////////////
      required,
      email,
      moduleList: ModuleReferenceList,
      config: {
        wrap: true,
        maxDate: "today",
      },
    };
  },

  computed: {
    ...mapGetters("salesPersonModule", {
      SalesPersonList: "salesperson",
      loading: "loading",
    }),
    ...mapGetters("customerModule", {
      details: "details",
      loading: "loading",
    }),
    ...mapGetters("segmentModule", {
      segments: "segments",
      loading: "loading",
    }),
    segmentOptions() {
      // Assuming this.segments is the array containing segment data
      return this.segments.map((segment) => {
        return {
          value: segment.segmentId,
          itemTitle: segment.name,
        };
      });
    },
    modalOptions() {
      if (this.modalType === "Product Interest") {
        return this.productInterestOptions;
      } else if (this.modalType === "Source") {
        return this.sourceOptions;
      } else if (this.modalType === "City") {
        return this.cityOptions;
      } else if (this.modalType === "JobTitle") {
        return this.jobTitleOptions;
      } else if (this.modalType === "HOBBIE") {
        return this.hobbiesOptions;
      }
      return []; // Return an empty array as fallback
    },
    sourceDDL() {
      return fnSortingDropdown(this.sourceOptions);
    },
    salesPersonDDL() {
      return fnSortingDropdown(this.optionsSalesPerson);
    },
    cityDDL() {
      return fnSortingDropdown(this.cityOptions);
    },
    jobTitleDDL() {
      return fnSortingDropdown(this.jobTitleOptions);
    },
    hobbiesDDL() {
      return fnSortingDropdown(this.hobbiesOptions);
    },
    productInterestDDL() {
      return fnSortingDropdown(this.productInterestOptions);
    },
  },
  async mounted() {
    await this.loadAndRefreshDetails()
    await this.getSalesPersonListAction().then(() => {
      this.SalesPersonList.map((v, i) =>
        this.optionsSalesPerson.push({
          value: v.id,
          text: `${v.firstName}` + " " + `${v.lastName}`,
        })
      );
    });
    await this.getSegmentsAction()
      .then((response) => {})
      .catch((response) => {
        console.log(response);
      });
    await this.loadAndRefreshDetails();
    this.sourceOptions = fnSortingDropdown(this.sourceOptions);
    this.optionsSalesPerson = fnSortingDropdown(this.optionsSalesPerson);
    this.cityOptions = fnSortingDropdown(this.cityOptions);
    this.jobTitleOptions = fnSortingDropdown(this.jobTitleOptions);
    this.hobbiesOptions = fnSortingDropdown(this.hobbiesOptions);
    this.productInterestOptions = fnSortingDropdown(this.productInterestOptions);
    this.segmentOptions = fnSortingDropdown(this.segmentOptions);
      
  },
  methods: {
    saveSocialMedia(value, text) {
      this.individual.source = value;
      this.selected = text;
    },

    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),
    ...mapActions("customerModule", [
      "getProfileDetailsListAction",
      "addProfileDetailAction",
      "deleteCustomerProfileDetailAction",
    ]),
    ...mapActions("segmentModule", [
      "getSegmentsAction",
      "removeSegmentAction",
      "addSegmentAction",
      "updateSegmentAction",
    ]),
    getSalePersonName(id) {
      const salesPerson = this.SalesPersonList.find((s) => s.id === id);
      return salesPerson
        ? salesPerson.firstName + " " + salesPerson.lastName
        : "";
    },
    async loadAndRefreshDetails() {
      this.$swal({
        title: "Loading...",
        text: "Please wait while the details are loading...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      const typeArrays = {
        SOURCE: this.sourceOptions,
        PRODUCTINTEREST: this.productInterestOptions,
        CITY: this.cityOptions,
        JOBTITLE: this.jobTitleOptions,
        HOBBIE: this.hobbiesOptions,
      };

      await this.getProfileDetailsListAction().then((response) => {
        for (const [type, optionsArray] of Object.entries(typeArrays)) {
          const filteredData = this.details.filter(
            (item) => item.type === type
          ).sort((a, b) => a.name.localeCompare(b.name));
          optionsArray.splice(
            0,
            optionsArray.length,
            ...filteredData.map((item) => ({
              value: item.id,
              text: item.name,
              itemTitle:
                type === "PRODUCTINTEREST" || "HOBBIE" ? item.name : undefined,
            }))
          );

          console.log(`Updated ${type} Options:`, optionsArray); // Debugging line
        }
      });
      this.$swal.close();
    },
    showModal(type) {
      this.modalType = type;
      this.modalId = `modal-${type.toLowerCase()}`;
      this.modalTitle = this.getModalTitle(type);

      this.currentOptions = this[`${type.toLowerCase()}Options`];
      this.$nextTick(() => {
        this.$bvModal.show(this.modalId);
      });
    },

    getModalTitle(type) {
    switch (type.toLowerCase()) {
      case "hobbie":
        return "Hobbies";
      case "productinterest":
        return "Product Interest";
      case "city":
        return "City";
      case "jobtitle":
        return "Job Title";
      case "source":
        return "Source";
      default:
        return "Unknown Type";
    }
  },

    addItem() {
      this.$swal({
        title: "Loading...",
        text: "Please wait while the item is being added...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      // Validate character limits for "JOBTITLE" and "SOURCE" types
      if (
        (this.modalType === "JOBTITLE" && this.newItem.length > 100) ||
        (this.modalType === "SOURCE" && this.newItem.length > 50)
      ) {
        // Show SweetAlert if character limit is exceeded
        this.$swal({
          title: "Error!",
          text:
            this.modalType === "JOBTITLE"
              ? "Job title should not exceed 100 characters."
              : "Source should not exceed 50 characters.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        return;
      }

      const payload = {
        name: this.newItem,
        type: this.modalType,
      };

      this.addProfileDetailAction(payload)
        .then(() => {
          this.loadAndRefreshDetails();
          this.showSuccessAlert("Item added successfully!");
          this.newItem = "";
          this.$bvModal.hide(this.modalId);
        })
        .catch((error) => {
        // console.log(error);
        console.log("This is an error: ", error);
         // Extract error message from the API response
      let errorMsg = "Failed to add item.";
      if (error.response?.data?.message) {
        errorMsg = error.response.data.message; // This ensures we show the correct backend error
      }

      // Display the error message using SweetAlert
      this.$swal({
        title: "Error!",
        text: errorMsg,
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    });
      this.newItem = "";
      this.$bvModal.hide(this.modalId);
    },

    deleteItem(value) {
      this.$swal({
        title: "Loading...",
        text: "Please wait while the item is being deleted...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      this.deleteCustomerProfileDetailAction(value)
        .then(() => {
          this.loadAndRefreshDetails();
          this.showSuccessAlert("Item deleted successfully!");
        })
        .catch((error) => {
          this.showErrorAlert("Failed to delete item: " + error.message);
          this.$swal.close();
        });
    },
    showErrorAlert(errorMessage) {
      this.$swal({
        title: "Error!",
        text:
          errorMessage || "An error occurred while adding the profile detail",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    showSuccessAlert(message) {
      this.$swal({
        title: "Success!",
        text: message,
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    resetForm() {
      this.$refs.formIndividual.reset();
    },
    async submitForm() {
      this.$emit("onchange", this.individual);
      console.log("individual", this.individual);
      let isValid = await this.$refs.formIndividual.validate();
      return isValid;
    },

    additionalFieldChanges(customFields) {
      this.individual.additionalFields = customFields;
    },
  },
  watch: {
    // Watch for changes to the individual object
    individual: {
      handler(newVal) {
        // Emit the updated individual data to the parent
        if (
          !(JSON.stringify(this.previousIndividual) === JSON.stringify(newVal))
        ) {
          this.$emit("update:individual", newVal);
          this.previousIndividual = newVal;
        }
      },
      deep: true, // Watch for nested changes in the individual object
    },
    "individual.dob"(newDate) {
      // Ensure that the year is within the range 1900 to 2100
      const year = new Date(newDate).getFullYear();
      console.log("year", year);
      if (year < 1900 || year > 2100) {
        // If the year is outside the range, set it to the nearest boundary
        const nearestYear = Math.min(Math.max(year, 1900), 2100);
        // Update individual.dob to the nearest year
        this.individual.dob = new Date(newDate);
        this.individual.dob.setFullYear(nearestYear);
        // Display a sweet alert to inform the user about the range
        this.$swal.fire({
          title: "Invalid Year",
          text: `Please select a year between 1900 and 2100.`,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    },
    "individual.percentage"(value) {
      if (value < 0 || value > 100) {
        this.individual.percentage = 0;
        // Display a sweet alert to inform the user about the percentage range
        this.$nextTick(() => {
          this.$swal.fire({
            title: "Invalid Percentage",
            text: `Please enter a value between 0 to 100.`,
            icon: "warning",
            confirmButtonText: "OK",
          });
        });
      }
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
